export function dockActionKey(entryId: string, actionId: string): string {
  return `${entryId}:${actionId}`;
}
